
import ContactSection from "./components/ContactSection.vue";
import IndustryGrowthStatement from "./components/IndustryGrowthStatement.vue";
import {
  buildBreadcrumbJsonLd,
  buildPageJsonLd,
  flatTreeData,
  findParentElements,
  getBreadList,
  getSiteOrigin,
} from "~/utils/index.js";
export default {
  asyncData({ app, route, store }) {
    const menus = store.state.menu.filter(m => m.type === "contact");

    const path = `/${route.path.split("/")[1]}`;
    const currentVO = app.$websiteDataHelper.getCurrentVO(menus, path);

    const flatArray = flatTreeData(menus);
    const breadList = findParentElements(route.meta[0].nodeid, flatArray);
    return {
      banner: currentVO?.bannerurl || "/img/knowledge-page-banner.png",
      title: (currentVO.name_ch || "news").toUpperCase().replace(/-/g, " "),
      contactShare: store.state.wmkcData.contactShare || {},
      baseInfo: store.state.baseInfo || {},
      breadList,
      currentVO,
    };
  },
  head() {
    const { meta } = this.$route;
    const { menu, baseInfo, footerData } = this.$store.state;
    const siteUrl = getSiteOrigin();
    const breadList = getBreadList(menu, this.currentVO, 1);

    return {
      script: [
        {
          type: "application/ld+json",
          json: [
            buildPageJsonLd({
              route: this.$route,
              meta,
              siteUrl,
              baseInfo,
              footerData,
              includePublisher: true,
            }),
            buildBreadcrumbJsonLd(breadList),
          ],
        },
      ],
    };
  },
  components: { ContactSection, IndustryGrowthStatement },
};
